import { render, staticRenderFns } from "./switch-img.vue?vue&type=template&id=139b6ce4&scoped=true"
import script from "./switch-img.vue?vue&type=script&lang=js"
export * from "./switch-img.vue?vue&type=script&lang=js"
import style0 from "./switch-img.vue?vue&type=style&index=0&id=139b6ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b6ce4",
  null
  
)

export default component.exports